module.exports = __webpack_public_path__ + "img/OthersLibrary.8310015d.png";